<app-dialog
  #dialog
  [key]="'org-chart-import-upload-modal'"
  [action]="'org-chart-import-upload'"
  [headerTheme]="'simple'"
  [title]="'Importar organograma'"
  [appendTo]="'body'"
  [hideDefaultFooter]="true"
  [maxWidth]="'560px'"
  (onClose)="onDialogClosed()">
  <div class="org-chart-upload">
    <p class="org-chart-upload__intro">
      A IA lê as empresas, os CNPJs e quem controla quem. Nada é gravado antes de você revisar.
    </p>

    @if (replacesOpenImport()) {
      <p class="org-chart-upload__warning">
        <i class="pi pi-info-circle"></i>
        Já existe uma importação aberta neste grupo. Enviar outro arquivo cancela a anterior.
      </p>
    }

    @if (!selectedFile()) {
      <app-document-attachment
        theme="dropzone"
        dropzoneTitle="Arraste o organograma aqui"
        dropzoneHint="ou clique para escolher o arquivo (PDF, PNG ou JPG, até 20 MB)"
        [maxFiles]="1"
        [attachedCount]="0"
        [acceptedFormats]="acceptedFormats"
        [invalidFileMessage]="'Escolha um arquivo PDF, PNG ou JPG de até 20 MB.'"
        (sendDocument)="onFileSelected($event)" />
    } @else {
      <div class="org-chart-upload__file">
        <i class="pi pi-file"></i>
        <div class="org-chart-upload__file-info">
          <span class="org-chart-upload__file-name" [title]="selectedFile()!.name">
            {{ selectedFile()!.name }}
          </span>
          <span class="org-chart-upload__file-size">{{ selectedFileSize() }}</span>
        </div>
        <app-button
          label="Trocar"
          theme="white"
          size="small"
          icon="pi pi-trash"
          [fitContent]="true"
          [disabled]="state.isStarting()"
          (sendButtonClick)="clearFile()" />
      </div>
    }

    <p class="org-chart-upload__hint">
      Empresas que já estão no grupo continuam onde estão, a menos que o organograma diga outra
      coisa.
    </p>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        label="Cancelar"
        theme="white"
        [disabled]="state.isStarting()"
        (sendButtonClick)="close()" />
      <app-button
        label="Ler organograma"
        icon="pi pi-upload"
        [disabled]="!isFormValid()"
        [isLoading]="state.isStarting()"
        [loadingText]="'Enviando...'"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
